module.exports = __webpack_public_path__ + "img/redsmiley.ffc66b65.png";